// extracted by mini-css-extract-plugin
export default {"container":"StudentClassroom_container__hV0KH","reconnecting":"StudentClassroom_reconnecting__GV2Xp","emptyContent":"StudentClassroom_emptyContent__OIWu1"};